import React from 'react';
import './booking.scss';
import {Col, Container, Row} from 'react-bootstrap';

function Booking() {
  return (
    <div id="booking" className="pt70">
      <div className="booking pt50">
        <Container>
          <Row>
              <Col sm={12} className="mb30">
                  <div className="section-title">Booking Information</div>
                  <p className="pt30 text-uppercase">How to Book</p>
                  <p>
                      Choose your preferred dates and accommodation using the booking form below.
                      Once we receive your request, we'll confirm your reservation by email or contact you directly if
                      we need any additional information.
                  </p>
                  <p>
                      This is our private home. <u>All shared areas are self-service</u>, but we're always happy to help
                      whenever needed.
                  </p>
                  <p>
                      <u>Important:</u> If you'd like to invite friends to visit during your stay, there is a visitor
                      fee of
                      <u> €15 per person</u>. They are welcome to enjoy all shared facilities, including the swimming
                      pool,
                      outdoor cinema, fire pit and barbecue area. Overnight stays in personal camping tents are also
                      possible by prior arrangement.
                  </p>
              </Col>
              <Col sm={6}>
                  <p className="text-uppercase">Check-in & Check-out</p>
                  <p>- Check-in 15:00 <br/>
                      - Check-out 11:00 am.<br/><br/>
                      Early check-in or late check-out may be available upon request.</p>

                  <a className='book-now-btn mb40 btn-orange' href='https://glamping-cy.book.page/'>Book your Stay</a>
            </Col>
            <Col sm={6} id="book-details">
              <p className="text-uppercase">Payments methods:</p>
              <p>- Cash<br />
                - Credit/Debit cards<br />
                - PayPal<br />
                - Revolut<br />
                - Bank transfer</p>
            </Col>
          </Row>

          {/* <Row className="booking-section mt40">
            <Col sm={12}>
              <h3>Details of your stay</h3>
              <script async="" data-form-id="815b937ceab27bfb" src="https://secured.sirvoy.com/widget/sirvoy.js"></script>
            </Col>
          </Row> */}
        </Container>
      </div>
    </div>
  )
}

export default Booking;
